export default __webpack_public_path__ + "static/media/6.fd8e9cfb.png";